"use client";

import React, { useState } from "react";

type PendingApprovalContextProps = {
  pendingApprovalReports: number;
  setPendingApprovalReports: (pendingApprovalReports: number) => void;
};

const PendingApprovalContext = React.createContext<PendingApprovalContextProps | null>(null);

export function usePendingApprovalContext() {
  const context = React.useContext(PendingApprovalContext);
  if (!context) {
    throw new Error("usePendingApprovalContext must be used within PendingApprovalProvider");
  }

  return context;
}

export function PendingApprovalProvider({ children }: { children: React.ReactNode }) {
  const [pendingApprovalReports, setPendingApprovalReports] = useState(0);

  return (
    <PendingApprovalContext.Provider value={{ pendingApprovalReports, setPendingApprovalReports }}>
      {children}
    </PendingApprovalContext.Provider>
  );
}
